import { render, staticRenderFns } from "./CurtainsDevice.vue?vue&type=template&id=4e5eb21f&scoped=true"
import script from "./CurtainsDevice.vue?vue&type=script&lang=js"
export * from "./CurtainsDevice.vue?vue&type=script&lang=js"
import style0 from "./CurtainsDevice.vue?vue&type=style&index=0&id=4e5eb21f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5eb21f",
  null
  
)

export default component.exports